import { AnswerContent } from '@karakuri-web/faq-type'
import { LogMetaVideoTouchDto } from '@karakuri-web/web/api-client'

export function detectVideoTouch(
  content: AnswerContent
): content is AnswerContent & { meta: LogMetaVideoTouchDto } {
  return (content.meta as LogMetaVideoTouchDto)?.type === 'video:video-touch'
}

export function getEmbedUrlForId(id: string | null): string {
  if (!id) return ''
  return `https://video-touch.com/video/${id}/embed`
}
